import request from '../request'

export function listCustomer(query) {
  return request.post('/sale/customer/list', {
    currentPage: query.pageIndex,
    pageSize: query.pageSize,
    customerCode: query.customerCode,
    customerName: query.customerName,
    isenabled: query.isenabled
  })
}

export function getCustomer(id) {
  return request.get(`/sale/customer/info/${id}`)
}

export function saveOrUpdateCustomer(data) {
  const path = data.customerId ? '/sale/customer/update' : '/sale/customer/save'
  return request.post(path, data)
}

export function deleteCustomer(customerId) {
  return request.post('/sale/customer/delete', { customerId })
}

export function listEnabledCustomer() {
  return request.get('/sale/customer/selectEnabled')
}
